import {
  useQuery,
  type QueryFunctionContext,
  type UseQueryOptions,
} from "@tanstack/react-query";
import {
  getRemoteMarkdown,
  getRemoteNotebook,
  type JupyterNotebook,
} from "./api";

const remoteContentStaleTimeMs = 10 * 60 * 1000;

export const remoteContentKeys = {
  all: ["remote-content"] as const,
  markdown: (url: string) =>
    [...remoteContentKeys.all, "markdown", url] as const,
  notebook: (url: string) =>
    [...remoteContentKeys.all, "notebook", url] as const,
};

export function remoteMarkdownQueryOptions(
  url: string,
): UseQueryOptions<
  string,
  Error,
  string,
  ReturnType<typeof remoteContentKeys.markdown>
> {
  return {
    queryKey: remoteContentKeys.markdown(url),
    queryFn: ({
      signal,
    }: QueryFunctionContext<ReturnType<typeof remoteContentKeys.markdown>>) =>
      getRemoteMarkdown(url, signal),
    enabled: Boolean(url),
    staleTime: remoteContentStaleTimeMs,
  };
}

export function remoteNotebookQueryOptions(
  url: string,
): UseQueryOptions<
  JupyterNotebook,
  Error,
  JupyterNotebook,
  ReturnType<typeof remoteContentKeys.notebook>
> {
  return {
    queryKey: remoteContentKeys.notebook(url),
    queryFn: ({
      signal,
    }: QueryFunctionContext<ReturnType<typeof remoteContentKeys.notebook>>) =>
      getRemoteNotebook(url, signal),
    enabled: Boolean(url),
    staleTime: remoteContentStaleTimeMs,
  };
}

export function useRemoteMarkdownQuery(url: string) {
  return useQuery(remoteMarkdownQueryOptions(url));
}

export function useRemoteNotebookQuery(url: string) {
  return useQuery(remoteNotebookQueryOptions(url));
}
